import { Routes } from '@router/routes';

export const NAVIGATE_LINKS = [
  {
    id: 1,
    name: 'Home',
    path: Routes.HOME,
  },
  {
    id: 2,
    name: 'Blog',
    path: Routes.BLOG,
  },
  {
    id: 3,
    name: 'Solutions',
    path: Routes.SOLUTIONS,
  },
  {
    id: 4,
    name: 'Contacts',
    path: Routes.CONTACTS,
  },
  {
    id: 5,
    name: 'Our Team',
    path: Routes.OUR_TEAM,
  },
  {
    id: 6,
    name: 'Services',
    path: Routes.SERVICES,
  },
  {
    id: 7,
    name: 'About Us',
    path: Routes.ABOUT_US,
  },
  {
    id: 8,
    name: 'FAQs',
    path: Routes.FAQS,
  },
];
